import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/media/Arrow-Shape.png'
import _imports_1 from '../../assets/media/Cross-Shape.png'
import _imports_2 from '../../../src/assets/media/copy.svg'
import _imports_3 from '../../../src/assets/media/Plane.svg'


const _withScopeId = n => (_pushScopeId("data-v-7a7ad906"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "action-footer" }
const _hoisted_2 = { class: "columns is-mobile menu" }
const _hoisted_3 = { class: "column has-text-centered mb-2" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lg fa-arrow-circle-up" })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Payer")
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"column has-text-centered mb-2\" data-v-7a7ad906><button disabled=\"true\" class=\"button custom-button is-recevoir has-text-weight-medium is-rounded action\" data-v-7a7ad906><span class=\"icon-text\" data-v-7a7ad906><span class=\"icon\" data-v-7a7ad906><i class=\"fas fa-lg fa-arrow-circle-down\" data-v-7a7ad906></i></span><span data-v-7a7ad906>Recevoir</span></span></button></div>", 1)
const _hoisted_8 = { class: "column has-text-centered mb-2" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lg fa-plus-circle" })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Recharger")
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "modal is-active"
}
const _hoisted_13 = { class: "modal-card" }
const _hoisted_14 = { class: "modal-card-head" }
const _hoisted_15 = { class: "is-flex is-justify-content-flex-start is-flex-shrink-0" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cross-shape",
  src: _imports_0,
  alt: "arrow_shape"
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-card-title is-title-shrink" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Envoyer de l'argent ")
], -1))
const _hoisted_19 = { class: "search-area" }
const _hoisted_20 = { class: "mt-4 is-flex is-justify-content-space-evenly is-align-items-center custom-search-bar" }
const _hoisted_21 = { class: "control has-icons-left custom-search-bar" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" })
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-flex is-justify-content-space-evenly is-align-items-center mt-3" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container is-fluid custom-heavy-line-separator" }, null, -1))
const _hoisted_25 = { class: "modal-card-body custom-modal-card-body" }
const _hoisted_26 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_27 = {
  key: 1,
  class: "notification is-light is-danger"
}
const _hoisted_28 = { key: 2 }
const _hoisted_29 = {
  key: 0,
  class: "custom-card is-flex-direction-column is-align-items-center is-justify-content-space-between"
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "custom-card-destinataire" }
const _hoisted_34 = {
  key: 1,
  class: "is-flex is-align-items-center is-justify-content-center"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "modal-card-foot is-justify-content-flex-end" }, null, -1))
const _hoisted_36 = {
  key: 1,
  class: "modal is-active"
}
const _hoisted_37 = { class: "modal-card" }
const _hoisted_38 = { class: "modal-card-head" }
const _hoisted_39 = { class: "is-flex is-flex-shrink-0" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cross-shape",
  src: _imports_0,
  alt: "arrow_shape"
}, null, -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "modal-card-title is-title-shrink" }
const _hoisted_43 = { class: "modal-card-body" }
const _hoisted_44 = { class: "is-flex is-flex-direction-column is-justify-content-space-evenly is-align-items-center mt-3" }
const _hoisted_45 = { class: "is-flex is-flex-direction-column custom-search-bar" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "frame3-title mt-3 mb-3" }, "Destinataire", -1))
const _hoisted_47 = { class: "is-flex is-justify-content-space-between is-align-items-center custom-user-select p-1" }
const _hoisted_48 = { class: "is-flex is-align-items-center" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figure", { class: "image is-32x32" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "is-rounded",
    src: "https://bulma.io/images/placeholders/128x128.png"
  })
], -1))
const _hoisted_50 = { class: "ml-1" }
const _hoisted_51 = { class: "is-flex is-flex-direction-column is-justify-content-space-evenly is-align-items-center mt-3" }
const _hoisted_52 = { class: "is-flex is-flex-direction-column custom-montant-input" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "frame3-sub-title mt-3 mb-3" }, "Montant", -1))
const _hoisted_54 = { class: "modal-card-foot is-justify-content-flex-end" }
const _hoisted_55 = { class: "custom-header-send-money is-flex is-align-items-center is-justify-content-space-between" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-flex is-align-items-center ml-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "is-size-4 ml-4" }, "Demander de l'argent")
], -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cross-shape",
  src: _imports_1,
  alt: "cross_shape"
}, null, -1))
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = { class: "is-flex is-flex-direction-column is-justify-content-space-evenly is-align-items-center mt-3" }
const _hoisted_60 = { class: "is-flex is-flex-direction-column custom-montant-input" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "frame3-sub-title mt-3 mb-3" }, "Montant", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-flex is-justify-content-center mt-6" }, null, -1))
const _hoisted_63 = {
  key: 0,
  class: "is-flex is-justify-content-center is-align-items-center mt-6"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ml-4" }, "copier le lien", -1))
const _hoisted_66 = [
  _hoisted_64,
  _hoisted_65
]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container custom-send-money mt-5" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "has-text-centered" }, " vous pourrez partager ce lien par mail à vos contacts. Ils recevront une invitation à se connecter ou à créer un compte pour vous envoyer l’argent. ")
], -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ml-4" }, "Générer un lien de paiement", -1))
const _hoisted_70 = [
  _hoisted_68,
  _hoisted_69
]
const _hoisted_71 = {
  key: 1,
  class: "modal is-active"
}
const _hoisted_72 = { class: "modal-card" }
const _hoisted_73 = { class: "modal-card-head" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-card-title is-title-shrink" }, "Créditer mon compte", -1))
const _hoisted_75 = { class: "modal-card-body" }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "frame3-sub-title mt-3 mb-3" }, "Compte à créditer", -1))
const _hoisted_79 = ["onClick"]
const _hoisted_80 = { class: "amount" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "frame3-sub-title mt-3 mb-3" }, "Montant à créditer", -1))
const _hoisted_82 = {
  key: 1,
  class: "notification is-info"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-3" }, " Un bon de commande pour votre rechargement a été créé. ", -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-3" }, " Pour compléter la demande de crédit, vous devez finaliser la transaction en vous rendant dans votre espace personnel Odoo: ", -1))
const _hoisted_85 = [
  _hoisted_83,
  _hoisted_84
]
const _hoisted_86 = {
  key: 2,
  class: "notification is-info"
}
const _hoisted_87 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_88 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_89 = { class: "modal-card-foot is-justify-content-flex-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_MyModal = _resolveComponent("MyModal")!
  const _component_Acc = _resolveComponent("Acc")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              disabled: !_ctx.hasActiveMoneyAccount,
              onClick: _cache[0] || (_cache[0] = ($event: any) => {
              ;(_ctx.showModalFrame1 = true), _ctx.resetSendMoney(), _ctx.searchRecipients()
            }),
              class: "button custom-button is-payer has-text-weight-medium is-rounded action"
            }, _hoisted_6, 8, _hoisted_4)
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              disabled: !_ctx.hasActiveMoneyAccount,
              class: "button custom-button is-recharger has-text-weight-medium is-rounded action",
              onClick: _cache[1] || (_cache[1] = ($event: any) => {;(_ctx.showModalFrameCreditMoney1 = true), _ctx.setFocus()})
            }, _hoisted_11, 8, _hoisted_9)
          ])
        ])
      ]),
      (_ctx.showModalFrame1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", {
              class: "modal-background",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModalFrame1 = false))
            }),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("header", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, [
                  _createElementVNode("a", {
                    class: "mr-3 mt-1",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModalFrame1 = false))
                  }, _hoisted_17)
                ]),
                _hoisted_18,
                _createElementVNode("button", {
                  class: "delete",
                  "aria-label": "close",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showModalFrame1 = false))
                })
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("p", _hoisted_21, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchName) = $event)),
                      onInput: _cache[6] || (_cache[6] = ($event: any) => (
                  _ctx.searchName.length === 0 || _ctx.searchName.length >= 3
                    ? _ctx.searchRecipients()
                    : null
                )),
                      class: "input",
                      type: "text",
                      placeholder: "adresse mail, téléphone"
                    }, null, 544), [
                      [_vModelText, _ctx.searchName]
                    ]),
                    _hoisted_22
                  ])
                ]),
                _hoisted_23,
                _hoisted_24
              ]),
              _createElementVNode("section", _hoisted_25, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createVNode(_component_loading, {
                        active: _ctx.isLoading,
                        "onUpdate:active": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isLoading) = $event)),
                        "can-cancel": false,
                        "is-full-page": false,
                        width: 50,
                        height: 50
                      }, null, 8, ["active"])
                    ]))
                  : (_ctx.searchRecipientError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, " Une erreur inattendue est survenue lors de la recherche de destinataires. Veuillez nous excuser pour la gêne occasionnée. "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        (_ctx.ownCurrenciesPartners.length !== 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              (_ctx.ownCurrenciesPartners)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ownCurrenciesPartners, (partner) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "pb-3 pt-3 is-flex flex-test is-flex-direction-row",
                                        key: partner
                                      }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["p-1 is-clickable is-align-items-center is-flex is-justify-content-flex-end favorit-icon-wrapper", [partner.is_favorite ? 'is-active' : '']]),
                                          onClick: ($event: any) => (
                      _ctx.toggleFavorite(partner),
                        (partner.is_favorite = partner.is_favorite
                          ? false
                          : true)
                    )
                                        }, [
                                          _createElementVNode("span", null, [
                                            _createElementVNode("i", {
                                              class: _normalizeClass(["far fa-star", [partner.is_favorite ? 'fas fa-star' : '']])
                                            }, null, 2)
                                          ])
                                        ], 10, _hoisted_31),
                                        _createElementVNode("div", {
                                          class: "p-2 is-clickable is-flex card-recipient-wrapper",
                                          onClick: ($event: any) => (
                      _ctx.setRecipient(partner),
                        (this.showModalFrame2 = true),
                        (this.showModalFrame1 = false),
                        _ctx.setFocusSend()
                    )
                                        }, [
                                          _createElementVNode("span", _hoisted_33, _toDisplayString(partner.name) + " " + _toDisplayString(partner.markBackend ? `(via ${partner.backendId})` : ""), 1)
                                        ], 8, _hoisted_32)
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_34, " Aucun destinataire de paiement a afficher "))
                      ]))
              ]),
              _hoisted_35
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showModalFrame2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _createElementVNode("div", {
              class: "modal-background",
              onClick: _cache[8] || (_cache[8] = ($event: any) => {;(_ctx.showModalFrame2 = false), (_ctx.showModalFrame1 = true)})
            }),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("header", _hoisted_38, [
                _createElementVNode("span", _hoisted_39, [
                  _createElementVNode("a", {
                    class: "mr-3 mt-1",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => {;(_ctx.showModalFrame2 = false), (_ctx.showModalFrame1 = true)})
                  }, _hoisted_41)
                ]),
                _createElementVNode("p", _hoisted_42, [
                  _createElementVNode("span", null, " Envoyer à " + _toDisplayString(_ctx.recipientName), 1)
                ]),
                _createElementVNode("button", {
                  class: "delete",
                  "aria-label": "close",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showModalFrame2 = false))
                })
              ]),
              _createElementVNode("section", _hoisted_43, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _hoisted_46,
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _hoisted_49,
                          _createElementVNode("h4", _hoisted_50, _toDisplayString(_ctx.recipientName), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.amount) = $event)),
                        ref: "amountSend",
                        type: "number",
                        min: "0",
                        class: "p-2"
                      }, null, 512), [
                        [_vModelText, _ctx.amount]
                      ]),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.message) = $event)),
                        class: "custom-textarea textarea mt-5",
                        placeholder: "Ajoutez un texte (optionnel)"
                      }, null, 512), [
                        [_vModelText, _ctx.message]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("footer", _hoisted_54, [
                _createElementVNode("button", {
                  class: "button custom-button custom-button-send-receive-money is-rounded action",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (
              _ctx.sendTransaction(),
                (_ctx.showModalFrame1 = false),
                (_ctx.showModalFrame2 = false)
            ))
                }, " Envoyer ")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showModalFrameAskMoney1)
      ? (_openBlock(), _createBlock(_component_MyModal, {
          key: 0,
          first: true,
          onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showModalFrameAskMoney1 = false))
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_55, [
              _hoisted_56,
              _createElementVNode("a", {
                class: "mr-5 p-2",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showModalFrameAskMoney1 = false))
              }, _hoisted_58)
            ])
          ]),
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _hoisted_61,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  min: "0",
                  class: "p-2",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.amountAsked) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.amountAsked]
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.message) = $event)),
                  class: "custom-textarea textarea mt-5",
                  placeholder: "Ajoutez un texte (optionnel)"
                }, null, 512), [
                  [_vModelText, _ctx.message]
                ]),
                _hoisted_62,
                (_ctx.linkGenerated)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                      _createElementVNode("p", {
                        class: "mr-4",
                        ref: "mylink"
                      }, _toDisplayString(_ctx.myLink), 513),
                      _createElementVNode("button", {
                        onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.copyUrl && _ctx.copyUrl(...args))),
                        class: "button custom-button custom-button-send-receive-money is-rounded action is-justify-content-space-evenly"
                      }, _hoisted_66)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_67
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("button", {
              class: "button custom-button custom-button-send-receive-money is-rounded action",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.genLink()))
            }, _hoisted_70)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showModalFrameCreditMoney1 || _ctx.globalBalCall)
      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
          _createElementVNode("div", {
            class: "modal-background",
            onClick: _cache[20] || (_cache[20] = ($event: any) => {
        ;(_ctx.showModalFrameCreditMoney1 = false),
          (_ctx.showCreditRefreshNotification = false)
      })
          }),
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("header", _hoisted_73, [
              _hoisted_74,
              _createElementVNode("button", {
                class: "delete",
                "aria-label": "close",
                onClick: _cache[21] || (_cache[21] = ($event: any) => {
            ;(_ctx.showModalFrameCreditMoney1 = false),
              (_ctx.showCreditRefreshNotification = false),
              _ctx.resetCredit()
          })
              })
            ]),
            _createElementVNode("section", _hoisted_75, [
              _createElementVNode("div", null, [
                (_ctx.myHyperLink.length === 0 && !_ctx.showCreditRefreshNotification)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                      (_ctx.creditableMoneyAccounts.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                            _hoisted_78,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.creditableMoneyAccounts, (account) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass([
                  _ctx.selectedCreditAccount === account ? 'selected' : 'unselected',
                  'account-selector',
                ]),
                                onClick: ($event: any) => (_ctx.setSelectedCreditAccount(account), _ctx.setFocus())
                              }, [
                                _createVNode(_component_Acc, {
                                  bal: account.bal,
                                  curr: account.curr,
                                  backend: account.backend,
                                  type: account.type,
                                  active: account.active
                                }, {
                                  name: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(account.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["bal", "curr", "backend", "type", "active"])
                              ], 10, _hoisted_79))
                            }), 256))
                          ]))
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("div", _hoisted_80, [
                        _hoisted_81,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.amountForCredit) = $event)),
                          ref: "amountcredit",
                          type: "number",
                          min: "0",
                          class: "input is-custom mb-3"
                        }, null, 512), [
                          [_vModelText, _ctx.amountForCredit]
                        ])
                      ], 512), [
                        [_vShow, 
                _ctx.selectedCreditAccount || _ctx.creditableMoneyAccounts.length === 1
              ]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.myHyperLink.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, _hoisted_85))
                  : _createCommentVNode("", true),
                (_ctx.showCreditRefreshNotification)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                      (_ctx.selectedCreditAccount.backend === 'comchain')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_87, " Une fois votre opération complétée dans votre espace personnel, votre crédit sera en attente de validation par un administrateur. Vous pourrez alors fermer cette fenêtre pour actualiser votre solde. "))
                        : _createCommentVNode("", true),
                      (_ctx.selectedCreditAccount.backend === 'cyclos')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_88, " Une fois votre opération complétée dans votre espace personnel, fermez cette fenêtre pour actualiser votre solde. "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("footer", _hoisted_89, [
              (
            _ctx.myHyperLink.length === 0 &&
            (_ctx.selectedCreditAccount || _ctx.creditableMoneyAccounts.length === 1) &&
            !_ctx.showCreditRefreshNotification
          )
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "button custom-button custom-button-send-receive-money is-rounded action",
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.newLinkTab()))
                  }, " Suivant "))
                : _createCommentVNode("", true),
              (_ctx.myHyperLink.length > 1)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: "button custom-button has-text-weight-medium custom-inverted is-rounded action",
                    onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.navigateToCreditOrder && _ctx.navigateToCreditOrder(...args)))
                  }, "Compléter la transaction dans mon espace personnel"))
                : _createCommentVNode("", true),
              (_ctx.showCreditRefreshNotification)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    class: "button custom-button has-text-weight-medium custom-inverted is-rounded action",
                    onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.closeAndRefresh && _ctx.closeAndRefresh(...args)))
                  }, "Fermer et rafraîchir"))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}